import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createPayouts = {
  name: "createPayouts" as const,
  input: z.object({
    teamId: zExt.objectId(),
    chargeImmediately: z.boolean(),
    limit: z.number().optional(),
  }),
  output: z.object({ success: z.boolean(), payoutIds: z.array(z.string()) }),
};
